import { pageTitleStyles as styles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPageTitle";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

styles.brandGridItem = {
    ...styles.brandGridItem,
    css: css`
        ${styles.brandGridItem?.css}

        &&& {
            img {
                width: auto;
                object-fit: contain;

                ${mediaQueriesBP.maxMD} {
                    max-height: 24px;
                }

                ${mediaQueriesBP.minMD} {
                    max-height: 32px;
                }
            }

            span {
                border-bottom: 1px solid transparent;
                text-decoration: none;

                &:hover {
                    border-bottom: 1px solid transparent;
                    text-decoration: none;
                }
            }
        }

        ${TypographyStyle} {
            display: inline-flex;
            font-weight: 400;
            border-bottom: 1px solid transparent;

            ${mediaQueriesBP.maxMD} {
                font-size: 14px;
                line-height: 18px;
                margin-bottom: 10px;
            }

            ${mediaQueriesBP.minMD} {
                font-size: 16px;
                line-height: 20px;
                margin-bottom: 5px;
            }
        }
    `,
};

styles.titleText = {
    ...styles.titleText,
    mergeCss: true,
    variant: "h4",
    as: "h1",
    transform: "none",
    css: css`
        margin-bottom: 0;
    `,
};
